<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync='page'
                   @current-change='changePage' @size-change="sizeChange">

        </avue-crud>
    </div>
</template>

<script>
    import { viewPeriodList } from '@/api/personal';

    export default {
        name: "periodList",
        props:['period'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10  //每页条数
                },
                data: [],
                option: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menu:false,
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    column: [
                        {
                            label: '期限列表ID',
                            prop: 'id'
                        }, {
                            label: '开始日期',
                            prop: 'start_date'
                        }, {
                            label: '到期日期',
                            prop: 'end_date'
                        }, {
                            label: '通话时长(分钟)',
                            prop: 'minute'
                        }, {
                            label: '扣费状态',
                            prop: 'status_txt'
                        }
                    ]
                }
            }
        },
        methods:{
            // 分页
            changePage(num){
                this.period.page = num;
                viewPeriodList(this.period).then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                })
            },
            // 切换每页条数
            sizeChange(val){
                this.period.limit = val;
                this.period.page = 1;
                this.getList();
            },
            getList(){
                viewPeriodList(this.period).then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage=1
                })
            }
        },
        created() {
            this.getList()
        }
    }
</script>

<style scoped>

</style>